import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { MiscService } from 'app/services/misc.service';

@Component({
  selector: 'app-frontpage',
  templateUrl: './frontpage.component.html',
  styleUrls: ['./frontpage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrontpageComponent implements OnInit {
  public content: any;
  public backgroundGradient: string;
  FinnishSelected = false;

  constructor(
    private router: Router,
    private miscService: MiscService
  ) {
    this.backgroundGradient = 'linear-gradient(#9b58b6, #cf3887)';
    this.FinnishSelected = this.miscService.getLanguage();
    this.miscService.languageChange.subscribe((value) => {
      this.FinnishSelected = value;
    });
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

}



// WEBPACK FOOTER //
// /Users/ilu/projektit/ets-tuloksia/src/app/frontpage/frontpage.component.ts